export default {
  NOT_VISIBLE: 'NOT_VISIBLE',
  INITIATE_CALL: 'INITIATE_CALL',
  OUTSIDE_OFFICE_HOURS: 'OUTSIDE_OFFICE_HOURS',
  PREMIUM_CALL_DISPLAY: 'PREMIUM_CALL_DISPLAY',
  NON_PREMIUM_CALL_DISPLAY: 'NON_PREMIUM_CALL_DISPLAY',
  ASK_CALL_CONNECTED: 'ASK_CALL_CONNECTED',
  CALL_CONNECTED_SUCCESSFULLY: 'CALL_CONNECTED_SUCCESSFULLY',
  CALL_NOT_CONNECTED: 'CALL_NOT_CONNECTED',
  APPLY_FOR_JOB: 'APPLY_FOR_JOB',
  JOB_NOT_DESIRED: 'JOB_NOT_DESIRED',
  SEE_OTHER_JOBS: 'SEE_OTHER_JOBS',
};
